import React, { Component } from 'react'
import SectionHeader from '../components/sections/SectionHeader'
import Card2 from '../components/cards/Card2'
import ServicesMP from '../components/sections/ServicesMP'
import PagesHeader from '../components/sections/PagesHeader'
import ServicesSection from '../components/sections/ServicesSection'
import { Helmet } from 'react-helmet'

export class Services extends Component {

    render() {
        return (
            <main>
                <Helmet>
                    {/* Meta Title */}
                    <title>ITnova Xidmətlər - İT Xidmətləri, Veb Dizayn, Mobil Tətbiq, SEO və Robototexnika</title>

                    {/* Meta Description */}
                    <meta name="description" content="ITnova Azərbaycanda İT xidmətləri, veb dizayn, mobil tətbiq hazırlığı, SEO və robototexnika üzrə tam həllər təklif edir. Biznesinizi inkişaf etdirmək üçün peşəkar texnoloji həllər." />

                    {/* Meta Keywords */}
                    <meta name="keywords" content="ITnova xidmətlər, İT xidmətləri, veb dizayn, mobil tətbiq hazırlığı, SEO, robototexnika, texnoloji həllər, itnova.az, Azərbaycan, İT şirkəti, biznes həlləri" />

                    {/* Open Graph Meta Tags (for social sharing) */}
                    <meta property="og:title" content="ITnova Xidmətlər - İT, Veb Dizayn, Mobil Tətbiq, SEO və Robototexnika Həlləri" />
                    <meta property="og:description" content="ITnova Azərbaycanda peşəkar İT xidmətləri, veb dizayn, mobil tətbiq hazırlığı və robototexnika üzrə tam həllər təklif edir. Bizimlə rəqəmsal dünyada fərq yaradın." />
                    <meta property="og:url" content="https://itnova.az/services" />
                    <meta property="og:type" content="website" />
                    <meta property="og:image" content="https://itnova.az/static/media/logo.76d56b1f9b610982be1a.png" />  {/* Loqonun URL ünvanını əlavə edin */}
                </Helmet>
                <PagesHeader
                    title="Xidmətlərimiz ilə tanış olun"
                    text="ITnova, ehtiyaclarınıza uyğun veb həllər, SEO, e-ticarət və mobil tətbiq xidmətləri ilə rəqəmsal uğura çatmağınıza kömək edir. Biznesinizi gücləndirmək üçün buradayıq."
                    className="header_back"


                />

                {/* <section className='p-[52px_0] mt-[32px] '>
                    <div className='container '>
                        <SectionHeader title="Xidmətlərimiz" />

                        <div className='grid grid-cols-3 gap-[32px] mt-[32px] '>
                            <Card2
                                className="bg-[#f4f8fc]"
                                text="loremmm"
                            />
                            <Card2
                                className="bg-[#f4f8fc]"
                            />
                            <Card2
                                className="bg-[#f4f8fc]"
                            />
                            <Card2
                                className="bg-[#f4f8fc]"
                            />
                        </div>
                    </div>

                </section> */}

                {/* <ServicesMP
                    card_shadow="shadow-md"
                /> */}

                <ServicesSection />
            </main>
        )
    }
}

export default Services